import request from '@/utils/request'
import Qs from 'qs'

export function loginByUsername (username, password) {
  const data = {
    username,
    password
  }
  return request({
    url: '/login/login',
    method: 'post',
    data
  })
}
// 用户登录
export function logingettoken (params) {
  return request({
    url: '/uaa/oauth/token',
    method: 'post',
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    transformRequest: [function (data) {
      data = Qs.stringify(data)
      return data
    }],
    params: {},
    data: {
      'username': params.username,
      'password': params.password,
      'captchaKey': params.captchaKey,
      'captchaCode': params.captchaCode,
      'grant_type': params.grant_type,
      'scope': params.scope,
      'client_id': params.client_id,
      'client_secret': params.client_secret
    }
  })
}

// refresh_token登录
export function refreshtoken (params) {
  return request({
    url: '/uaa/oauth/token',
    method: 'post',
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    transformRequest: [function (data) {
      data = Qs.stringify(data)
      return data
    }],
    params: {},
    data: {
      'refresh_token': params.refresh_token,
      'grant_type': params.grant_type,
      'client_id': params.client_id,
      'client_secret': params.client_secret
    }
  })
}

export function logout () {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}

export function getUserInfo (token) {
  return request({
    url: '/api/brew/device',
    method: 'get',
    params: { token }
  })
}

// 获取验证码
export function getCodeImg () {
  return request({
    url: '/uaa/captcha',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/services/login.js